import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Outsourcing = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    loadLanguageFile("Outsourcing", "home/home_Outsourcing_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Outsourcing || { Main: {} };

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const outsourcingData = [
    {
      question: LANGUAGE.Main.Question1,
      answerTitle: LANGUAGE.Main.AnswerTitle1,
      answer: LANGUAGE.Main.Answer1,
    },
    {
      question: LANGUAGE.Main.Question2,
      answerTitle: LANGUAGE.Main.AnswerTitle2,
      answer: LANGUAGE.Main.Answer2,
    },
    {
      question: LANGUAGE.Main.Question3,
      answerTitle: LANGUAGE.Main.AnswerTitle3,
      answer: LANGUAGE.Main.Answer3,
    },
    {
      question: LANGUAGE.Main.Question4,
      answerTitle: LANGUAGE.Main.AnswerTitle4,
      answer: LANGUAGE.Main.Answer4,
    },
  ];

  return (
    <div className="container-fluid outsourcing py-5">
      <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: '600px' }}>
        <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
        <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
      </div>

      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <div className="pb-5">
              <h1 className="display-4">{LANGUAGE.Main.Content3}</h1>
              <h4 className="text-primary">{LANGUAGE.Main.Content4}</h4>
            </div>
            <div className="accordion bg-light rounded p-4">
              {outsourcingData.map((item, index) => (
                <div className="accordion-item border-0 mb-4" key={index}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button text-dark fs-5 fw-bold rounded-top ${activeIndex === index ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => toggleItem(index)}
                    >
                      {item.question}
                    </button>
                  </h2>
                  <div className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}>
                    <div className="accordion-body my-2">
                      <h5>{item.answerTitle}</h5>
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6">
            <div className="outsourcing-img RotateMoveRight rounded">
              <img src="img/outsourcing-img.jpg" className="img-fluid rounded w-100" alt="Outsourcing" />
              <a className="outsourcing-btn btn btn-primary rounded-pill text-white py-3 px-5" href="/outsourcing">
                {LANGUAGE.Main.Content5}<i className="fas fa-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Outsourcing;
